import { Component } from '@angular/core';

@Component({
    selector: 'backend-build-parent',
    templateUrl: './build-parent.component.html',
    styleUrls: ['./build-parent.component.css'],
    standalone: false
})
export class BuildParentComponent {

}
